import { render, staticRenderFns } from "./TreatmentForm.vue?vue&type=template&id=cc2c4eb6&scoped=true"
import script from "./TreatmentForm.vue?vue&type=script&lang=js"
export * from "./TreatmentForm.vue?vue&type=script&lang=js"
import style0 from "./TreatmentForm.vue?vue&type=style&index=0&id=cc2c4eb6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cc2c4eb6",
  null
  
)

export default component.exports